<template>
  <view class="swipe-item" wx:style="{{itemStyle}}" bindtap="handleClick">
    <view class="image" style="backgroundImage : url({{item}})" wx:style="{{imageStyle}}"/>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'
  const px2vw = (px) => `${(px / 750) * 100}vw`

  createComponent({
    props: {
      item: {
        type: String,
        value: ''
      },
      index: {
        type: Number,
        value: 0
      },
      active: {
        type: Boolean,
        value: false
      },
      vertical: {
        type: Boolean,
        value: false
      },
      displayMultipleItems: {
        type: Number,
        value: 1
      },
      spaceBetween: {
        type: Number,
        value: 0
      },
      noTransition: {
        type: Boolean,
        value: false
      },
      itemSize: {
        type: Number,
        optionalTypes: [String],
        value: 0
      },
      imageStyle: {
        type: Object,
        value: {}
      }
    },
    computed: {
      itemStyle() {
        const size = this.vertical ? 'height' : 'width'
        const scale = this.active ? 1 : 0.8
        const anotherSize = this.vertical ? 'width' : 'height'
        return {
          flexShrink: 0,
          [size]: this.itemSize ? `${px2vw(this.itemSize)}` : `${100 / this.displayMultipleItems}%`,
          [anotherSize]: '100%',
          marginRight: this.active ? `${this.vertical ? 0 : px2vw(this.spaceBetween)}` : 0,
          marginLeft: this.active ? `${this.vertical ? 0 : px2vw(this.spaceBetween)}` : 0,
          marginBottom: `${this.vertical ? px2vw(this.spaceBetween) : 0}`,
          transform: `scale(${scale})`,
          transition: `transform ${this.noTransition ? 0 : 0.3}s ease-in-out`
        }
      }
    },
    methods: {
      handleClick() {
        this.triggerEvent('click',{
          index: this.index,
          item: this.item
        })
      }
    }
  })
</script>

<style scoped lang="stylus">
  .swipe-item
    position relative
    display flex
    justify-content center
    align-items center
    .image
      height 100%
      width 100%
      background-repeat no-repeat
      background-size 100% 100%
      background-position center
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {}
  }
</script>